<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
    <button v-if="rowData.status !== 'Mottagen'" class="btn btn-success mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Godsmottag' | translate }}</button>
    <button class="btn btn-secondary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Visa artiklar' | translate }}</button>
    <button v-if="rowData.status === 'Utkast'" class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Redigera' | translate }}</button>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      if (action === 'delete') {
        if (confirm(this.$t('Are you sure?'))) {
          this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
        }
      } else {
        this.$router.push({ path: this.$route.path + '/' + action + '/' + data.id })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTablePurchasingActions.vue?05770b68